var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIssueSelectMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6756 8.84337C10.8577 8.65066 10.8577 8.34934 10.6756 8.15663L7.36345 4.6508C7.05281 4.322 6.5 4.54184 6.5 4.99417L6.5 12.0058C6.5 12.4582 7.05281 12.678 7.36345 12.3492L10.6756 8.84337Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIssueSelectMore);
export default __webpack_public_path__ + "static/media/issue-select-more.f639e664414ca29f4b1cb4a7ff15fd1c.svg";
export { ForwardRef as ReactComponent };